import React from "react";
import {useTranslation} from "react-i18next";

const PackageDottedSeparator = () => {
    const {t} = useTranslation();
    return (
        <div className={"PackageDottedSeparator flex flex-row items-center gap-4 lg:gap-6 xl:gap-8"}>
            {/* Dotted separator — the plus interrupts the line under the chevron column */}

            <div className={"flex-1 lg:flex-none lg:w-[260px] xl:w-[295px] shrink-0 border-t border-dashed border-[#D9D9D9]"} />
            <div className={"w-[24px] shrink-0 flex items-center justify-center"}>
                <span className={"text-[18px] leading-none font-bold text-mid-grey"}>+</span>
            </div>
            <div className={"flex-1 border-t border-dashed border-[#D9D9D9]"} />
        </div>
    );
};

export default PackageDottedSeparator;
